<template>
  <div>
    <Modal
      v-show="isModalVisible"
      :constat="flux.constat"
      :type="flux.level2"
      @close="closeModal"
      @edit="editRepair"
      @evenement="evenement"
    />
    <v-row>
      <v-col cols="12">
        <h2 class="mt10 pt10">TROU / ACCROC / DÉCHIRURE</h2>
        <div class="spacer"></div>
        <div>
          <b>Choisissez le type de réparation que vous souhaitez</b>
        </div>
        <div class="spacer"></div>
        <v-tabs
          v-model="active_tab"
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows
          @change="onChangeTab"
        >
          <v-tab href="#reparation_simple_jean">REPRISE DE LA TOILE</v-tab>
          <v-tab href="#empiecement">EMPIÈCEMENT</v-tab>
          <v-tab href="#patch">PATCH</v-tab>
          <v-tab href="#genouillere">GENOULLIÈRES</v-tab>

          <v-tab-item id="reparation_simple_jean">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"/>
            </KeepAlive>
          </v-tab-item>
          <v-tab-item id="empiecement">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"/>
            </KeepAlive>
          </v-tab-item>
          <v-tab-item id="patch">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"/>
            </KeepAlive>
          </v-tab-item>
          <v-tab-item id="genouillere">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"/>
            </KeepAlive>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapMutations, mapState} from 'vuex'
import Modal from '../Modal.vue';


export default {
  name: 'Calculateur',
  data() {
    return {
      tabName: null,
      isModalVisible: false,
    }
  },
  computed: {
    ...mapState('cart-app', ['cards', 'products']),
    ...mapState('flux-app', ['flux']),
    active_tab: {
      get() {
        return this.flux.activeTab
      },
      set(newValue) {
        this.setActiveTab(newValue)
      }
    }
  },
  methods: {
    ...mapMutations('flux-app', ['setConstat', 'incrementCptProduct', 'setcptReparation', 'setActiveTab']),
    ...mapMutations('cart-app', ['addProduct', 'getTotalCart']),
    onChangeTab(value) {
      this.tabName = value
      this.setActiveTab(value)
    },
    editRepair(indexes) {
      this.$emit('edit', indexes)
    },
    evenement($value) {
      this.$emit('evenement', $value)
    },
    showModal() {
      this.$emit('showmodal', this.flux.level2)
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
  components: {
    Modal,
    'reparation_simple_jean': () => import('./reparation_simple_jean.vue'),
    'empiecement': () => import('./empiecement.vue'),
    'patch': () => import('./patch.vue'),
    'genouillere': () => import('./genouillere.vue')
  }
}
</script>
